import { inject, Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccessControlService } from './access-control.service';

@Injectable({
    providedIn: 'root'
})
export class MenuSectionByPermissionsService {
    private ac = inject(AccessControlService);

    routesModel$: Observable<MenuItem[]> = combineLatest([
        this.ac.canView('Organization'),
        this.ac.canView('Review'),
        this.ac.canView('Project'),
        this.ac.canView('Employee'),
        this.ac.canView('Booking'),
        this.ac.canView('Location'),
        this.ac.canView('User'),
        this.ac.canView('ExternalAccess'),
        this.ac.canView('Role'),
        this.ac.canView('Nsi'),
        this.ac.canView('Workflow.Template'),
        this.ac.canView('Workflow.Request'),
        this.ac.canView('Notification.Delivery'),
        this.ac.canView('Notification.Mail'),
        this.ac.canView('ApiUser'),
        this.ac.canView('TestObjects'),
        this.ac.canView('BalanceHolder')
    ]).pipe(
        map(([orgView, reviewView, projectView, employeeView, bookingView, locationView, userView, externalAccessView, roleView, nsiView, workflowTemplateView, workflowRequestView, notificationDelivery, notificationMail, apiUsers, testObjectsView, balanceHolderView]) => {
            const model: MenuItem[] = [
                {
                    label: 'Организации',
                    description: 'Реестр, где собрана полная информация о компаниях и учреждениях города.',
                    expanded: true,
                    visible: orgView || reviewView || projectView || employeeView || balanceHolderView,
                    items: [
                        { label: 'Организации', icon: 'pi pi-fw pi-building', routerLink: ['organizations', 'organization'], visible: orgView },
                        { label: 'Отзывы', icon: 'pi pi-fw pi-comments', routerLink: ['organizations', 'reviews'], visible: reviewView },
                        { label: 'Проекты', icon: 'pi pi-fw pi-briefcase', routerLink: ['organizations', 'projects'], visible: projectView },
                        { label: 'Сотрудники', icon: 'pi pi-fw pi-users', routerLink: ['organizations', 'employees'], visible: employeeView },
                        { label: 'Балансодержатели', icon: 'pi pi-fw pi-id-card', routerLink: ['organizations', 'balanceholders'], visible: balanceHolderView }
                    ]
                },
                {
                    label: 'Заявки',
                    description: 'Заявки',
                    expanded: true,
                    visible: workflowTemplateView || workflowRequestView,
                    items: [
                        { label: 'Модели заявок', icon: 'pi pi-fw pi-user', routerLink: ['requests', 'models'], visible: workflowTemplateView },
                        { label: 'Заявки', icon: 'pi pi-fw pi-sitemap', routerLink: ['requests', 'requests'], visible: workflowRequestView },
                    ]
                },
                {
                    label: 'Рассылки',
                    description: 'Рассылки',
                    expanded: true,
                    visible: notificationDelivery || notificationMail,
                    items: [
                        { label: 'Рассылки', icon: 'pi pi-fw pi-envelope', routerLink: ['mailing', 'mailings'], visible: notificationDelivery },
                        { label: 'Письма', icon: 'pi pi-fw pi-file', routerLink: ['mailing', 'notifications'], visible: notificationMail },
                    ]
                },
                {
                    label: 'Бронирование',
                    description: 'Реестр бронирования',
                    expanded: true,
                    visible: bookingView,
                    items: [
                        { label: 'Календарь бронирования', icon: 'pi pi-fw pi-calendar', routerLink: ['booking', 'locations'], visible: bookingView }
                    ]
                },
                {
                    label: 'Аренда локаций',
                    description: 'Раздел локаций',
                    expanded: true,
                    visible: locationView,
                    items: [{ label: 'Локации', icon: 'pi pi-fw pi-map', routerLink: ['locations'], visible: locationView }]
                },
                {
                    label: 'Административные реестры',
                    description: 'Административные разделы',
                    expanded: true,
                    visible: userView || externalAccessView || roleView || nsiView || apiUsers || testObjectsView,
                    items: [
                        { label: 'Пользователи', icon: 'pi pi-fw pi-user', routerLink: ['admin', 'users'], visible: userView },
                        { label: 'Внешний доступ', icon: 'pi pi-fw pi-sitemap', routerLink: ['admin', 'external-access'], visible: externalAccessView },
                        { label: 'Роли', icon: 'pi pi-fw pi-star', routerLink: ['admin', 'roles'], visible: roleView },
                        { label: 'НСИ', icon: 'pi pi-fw pi-table', routerLink: ['admin', 'nsi'], visible: nsiView },
                        { label: 'API Пользователи', icon: 'pi pi-fw pi-key', routerLink: ['admin', 'api-users'], visible: apiUsers },
                        { label: 'Тестовые объекты', icon: 'pi pi-fw pi-box', routerLink: ['admin', 'test-objects'], visible: testObjectsView },
                    ]
                },
            ];

            return model;
        })
    );
}
